
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CormackLehane",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/CormackLehane.vue